<template>
  <div class="foot">
    <div class="goTop">
      <div class="circle" @click="gotop">
        <img src="../../../static/images/base/gotop.png" alt />
      </div>
    </div>
    <div class="container">
      <div>
        <div class="footerInm">
          <div
            v-for="(item,index) in footerMenulist"
            :key="index"
            @click="goToNext(item.routerUrl)"
          >
            <router-link :to="item.routerUrl">
              <template v-if="isChinese">{{item.cName}}</template>
              <template v-else>{{item.eName}}</template>
            </router-link>
          </div>
        </div>
        <div class="innerC">
          <div class="imgbox">
            <img :src="erweima" alt />
          </div>
          <p>{{weclome}}</p>
        </div>
      </div>
    </div>
    <div class="MediaTest">{{ownership}}<a style="margin-left:10px" href="https://beian.miit.gov.cn">浙ICP备19000076号-1</a></div>
    <!-- <div class="MediaTest"><a href="https://beian.miit.gov.cn">浙ICP备19000076号-1</a></div> -->
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      isChinese: undefined,
      ownership: "",
      weclome: "",
      erweima: '',
      footerMenulist: [
        { cName: "首页", eName: "Home", routerUrl: "/" },
        { cName: "关于计氏", eName: "About Jishi", routerUrl: "/AboutUs" },
        { cName: "解决方案", eName: "Solution", routerUrl: "/Solution" },
        { cName: "联系我们", eName: "Contact Us", routerUrl: "/ContactUs" },
        { cName: "新闻中心", eName: "News Center", routerUrl: "/News" },
        {
          cName: "下载中心",
          eName: "Download Center",
          routerUrl: "/downLoadCenter"
        }
      ]
    };
  },
  created() {
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
    this.getErweiMa()

    if (this.isChinese) {
      this.ownership = "Copyright © 2020 nbjsjs.com 版权所有";
      this.weclome = "欢迎关注";
    } else {
      this.ownership = "Copyright © 2020 nbjsjs.com 版权所有(英文版)";
      this.weclome = "Subscribe Us";
    }
  },
  computed: {
    setCAE() {
      return this.$store.state.cAeSatus;
    }
  },
  watch: {
    setCAE(newVal) {
      this.isChinese = newVal === 1 ? true : false;
    },
    isChinese: function(newVal) {
      if (newVal) {
        this.ownership = "Copyright © 2020 nbjsjs.com 版权所有";
        this.weclome = "欢迎关注";
      } else {
        this.ownership = "Copyright © 2020 nbjsjs.xcom 版权所有(英文版)";
        this.weclome = "Subscribe Us";
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrolltop = scrollTop;
    },
    gotop() {
      let timer = setInterval(() => {
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrolltop - 90;
        if (this.scrolltop === 0) {
          clearInterval(timer);
        }
      }, 15);
    },
    goToNext(url) {
      this.$router.push({ path: url });
    },
    getErweiMa() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: '二维码'
          }
        })
        .then(
          function(res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.erweima = resdata.logo

            }
          }.bind(this)
        );
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.goTop {
  background: #edac1a;
  padding-top: 1px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10vw;
  cursor: pointer;
}
.circle img {
  width: 100%;
}
.container {
  width: 100%;
  padding: 6vw 0;
  background: #646363;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footerInm {
  display: flex;
}
.footerInm > div {
  margin-left: 2vw;
}
.footerInm > div a {
  font-size: 1.8rem;
  color: white;
}
.footerInm > div:nth-child(1) {
  margin-left: 0;
}
.innerC {
  text-align: center;
}
.imgbox {
  margin: 5vh 0 3vh 0;
}
.imgbox img {
  width: 5vw;
  height: 5vw;
  min-width: 50px;
  min-height: 50px;
}
.innerC p {
  color: white;
  font-size: 1.8rem;
}
.MediaTest {
  color: black;
  text-align: center;
  padding: 13px 0;
}
@media(max-width: 800px){
  .circle {
  width: 30px;
  height: 30px;
}
.footerInm {
  display: none;
}
}
</style>



// WEBPACK FOOTER //
// src/components/footerBase/index.vue